// experiments constants
export const defaultExperimentItem = {
  name: "",
  description: "",
  period: 0,
  traffic: 0.5,
  variants: [],
  is_active: false,
  is_for_new_users: false,
  cohort_id: null,
  experiment_type: 'ab'
};

export const experimentColumns = [
  { label: "Name", prop: "name" },
  { label: "Traffic", formatter: (item) => `${item.traffic * 100}%` },
  {
    label: "Type", formatter: ({ experiment_type, variants: v }) => {
      switch (experiment_type) {
        case 'variants':
          return `Variants (${v.length})`;
        case 'feature_toggle':
          return 'Feature toggle';
        case 'ab':
        default:
          return 'A/B (boolean)';
      }
    }
  },
  { label: "Active", formatter: (item) => (item.is_active ? "✅" : "❌") },
];

// kpi constants
export const defaultKpiItem = {
  name: "",
  derived_event: null,
  conversion: null,
  value_unit: "absolute",
  count_unique_users: false,
};

export const kpiColumns = [
  { label: "Name", prop: "name" },
  {
    label: "Derived event / Conversion",
    formatter: (item) => {
      const { derived_event, conversion } = item;
      const kpiEventType = derived_event || conversion;
      return kpiEventType.name;
    },
  },
];

// events constants
export const derivedEventColumns = [
  { label: "Name", prop: "name" },
  {
    label: "Events",
    formatter: (item) => {
      const previewAmount = 2;
      const deString = item.events.slice(0, previewAmount).join(", ");
      const length = item.events.length - previewAmount;
      const moreString = length > 0 ? `and ${length} more...` : "";
      return `${deString} ${moreString}`;
    },
  },
];

export const conversionColumns = [{ label: "Name", prop: "name" }];

export const defaultEventItem = {
  // conversion fields:
  from_event: "",
  to_event: "",
  window: 30,

  // derived event fields
  name: "",
  events: [],
  hosts: "",
  threshold: 1,
};

// features constants
export const defaultFeatureItem = {
  name: "",
  owner: null,
  contributors: [],
  reports: [],
};

export const featureColumns = [
  { label: "Name", prop: "name" },
  { label: "Owner", prop: "owner.email" },
  { label: "Parent", prop: "parent.name" },
  { label: "Usage Events", prop: "usage_events" },
];

// dashboards constants
export const dashboardColumns = [
  { label: "Owner", prop: "owner.email" },
  {
    label: "Reports",
    formatter: (item) => {
      if (!item.reports || !item.reports.length) {
        return "No reports...";
      }
      const previewAmount = 2;
      const reportsString = item.reports
        .slice(0, previewAmount)
        .map((r) => r.name)
        .join(", ");
      const length = item.reports.length - previewAmount;
      const moreString = length > 0 ? `and ${length} more...` : "";
      return `${reportsString} ${moreString}`;
    },
  },
];

// reports constants
export const reportColumns = [{ label: "Name", prop: "name" }];
